<capra-icon
  capraTooltip
  tooltipContent="Run Cell & Advance (Shift + Return)"
  [tooltipPlacement]="toolTipPlacement"
  [tooltipSize]="tooltipSize"
  icon="icon-control-play"
  [class.disabled]="!canRun"
  (click)="run()"
>
</capra-icon>
